export default "__VITE_ASSET__wz8JATgZ__"